import React, { useState, useEffect } from 'react';
import {
  Container,
  Grid,
  Typography,
  Box,
  CircularProgress,
  Button,
  Chip,
  Paper,
  ToggleButton,
  ToggleButtonGroup,
  Stack,
  TextField,
  InputAdornment,
} from '@mui/material';
import {
  ArrowBack as ArrowBackIcon,
  FilterList as FilterListIcon,
  Sort as SortIcon,
  Search as SearchIcon,
} from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router-dom';
import { useUser } from 'shared/helpers/axios';
import { axiosService } from 'shared/helpers/axios';
import CallRelevanceCard from 'components/funding/CallRelevanceCard';
import BackButton from 'components/common/buttons/BackButton';

const AllRelevantCalls = () => {
  const navigate = useNavigate();
  const { profileId } = useParams();
  const { user: currentUser } = useUser();
  
  const [loading, setLoading] = useState(true);
  const [relevantCalls, setRelevantCalls] = useState([]);
  const [userProfile, setUserProfile] = useState(null);
  const [sortBy, setSortBy] = useState('score'); // 'score', 'deadline', 'skills', 'interests', 'status'
  const [filterBy, setFilterBy] = useState('all'); // 'all', 'skills', 'interests', 'both'
  const [statusFilter, setStatusFilter] = useState('all'); // 'all', 'open', 'upcoming', 'closed'
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    fetchRelevantCalls();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


      


//       setUserProfile(profile);

//       if (!profile) {
//         setRelevantCalls([]);
//         return;
//       }

//       // Get user's skills and research interests
//       const userSkills = profile.skills || [];
//       const userInterests = profile.research_interests || [];

//       // Get skill IDs from user skills
//       const userSkillIds = userSkills.map(s => s.skill?.id).filter(Boolean);
      
//       // Get research category codes and names for matching with call categories
//       const userInterestAreaCodes = userInterests.map(i => i.category?.code).filter(Boolean);
//       const userInterestAreaNames = userInterests.map(i => i.category?.name).filter(Boolean);


//       // Calculate match score for each call with detailed matching information
//       const callsWithScores = calls.map(call => {
//         let score = 0;
//         const matchingSkills = [];
//         const matchingInterests = [];
        
//         // Match user skills with call skills
//         const callSkills = call.skills || [];
//         callSkills.forEach(cs => {
//           const skillId = cs?.id;
//           if (skillId && userSkillIds.includes(skillId)) {
//             matchingSkills.push(cs);
//             score += 1; // Weight skills higher
//           }
//         });

//         // Match user research interests with call categories
//         const callCategories = call.categories || [];
//         callCategories.forEach(cc => {
//           const categoryCode = cc?.code;
//           const categoryName = cc?.name;
          
//           if ((categoryCode && userInterestAreaCodes.includes(categoryCode)) ||
//               (categoryName && userInterestAreaNames.includes(categoryName))) {
//             matchingInterests.push(cc);
//             score += 1;
//           }
//         });

//         return {
//           ...call,
//           matchScore: score,
//           skillMatches: matchingSkills.length,
//           interestMatches: matchingInterests.length,
//           matchingSkills,
//           matchingInterests,
//         };
//       });

//       // Filter and sort by match score
//       const relevantCallsList = callsWithScores
//         .filter(call => call.matchScore > 0)
//         .sort((a, b) => b.matchScore - a.matchScore);

//       setRelevantCalls(relevantCallsList);
//     } catch (e) {
//       console.error('Error fetching relevant calls:', e);
//       setRelevantCalls([]);
//     } finally {
//       setLoading(false);
//     }
//   };

  // Apply filtering
  
  //   const fetchUserProfileAndCalls = async () => {
    //     setLoading(true);
    //     try {
    //       // Fetch user profile


    const fetchRelevantCalls = async () => {
      
        setLoading(true);
        try {
  
            const targetUserId = profileId || currentUser?.id;
            let userProfile = null;
            if (targetUserId) {
                if (String(currentUser?.id) === String(targetUserId)) {
                    userProfile = currentUser;
                } else {
                    const profileRes = await axiosService.get(`/users/${targetUserId}/`);
                    userProfile = profileRes.data;
                }
            }

        // Get user's skills and research interests
        const userSkills = userProfile.skills || [];
        const userInterests = userProfile?.research_interests || [];
  
        // Get skill IDs from user skills
        const userSkillIds = userSkills.map(s => s.skill?.id).filter(Boolean);
        
        // Get research category codes and names for matching with call categories
        const userInterestAreaCodes = userInterests.map(i => i.category?.code).filter(Boolean);
        const userInterestAreaNames = userInterests.map(i => i.category?.name).filter(Boolean);
  
        // console.log('User research interests:', userInterests);
        // console.log('User interest codes:', userInterestAreaCodes);
        // console.log('User interest names:', userInterestAreaNames);
        // console.log('User skill IDs:', userSkillIds);
  
        // Fetch recent active calls
        const relevantCalls = await axiosService.get('/relevant-calls/',
          
          { params: {
              page_size: 250,
              ordering: '-created'
            }
          });
  
        // console.log('Fetched calls for relevance matching:', relevantCalls?.data?.results || relevantCalls?.data);
  
        const calls = relevantCalls?.data?.results || relevantCalls?.data || [];
        
        // Debug: Check first call structure
        // if (calls.length > 0) {
        //   console.log('First call sample:', {
        //     code: calls[0].code,
        //     categories: calls[0].categories,
        //     skills: calls[0].skills,
        //     categoriesType: typeof calls[0].categories,
        //     skillsType: typeof calls[0].skills,
        //   });
        // }
  
        // Calculate match score for each call
        const callsWithScores = calls.map(call => {
          let score = 0;
          const matchingSkills = [];
          const matchingInterests = [];
          
          // Match user skills with call skills (both use Skill entity)
          const callSkills = call?.skills || [];
          callSkills.forEach(cs => {
            const skillId = cs?.id;
            if (skillId && userSkillIds.includes(skillId)) {
              matchingSkills.push(cs);
              score += 1; // Weight skills higher
            }
          });
  
          // Match user research interests with call categories (by code and name)
          const callCategories = call?.categories || [];
          
          callCategories.forEach(cc => {
            // call.categories is a flat array of category objects from the backend
            const categoryCode = cc?.code;
            const categoryName = cc?.name;
            
            // Match by code (more precise)
            if (categoryCode && userInterestAreaCodes.includes(categoryCode)) {
              matchingInterests.push(cc);
              score += 1;
            }
            // Match by name (fallback if code doesn't match)
            else if (categoryName && userInterestAreaNames.includes(categoryName)) {
              matchingInterests.push(cc);
              score += 1;
            }
          });
  
          // Debug logging for calls with any score
          if (score > 0) {
            // console.log(`Call ${call.code}: ${matchingSkills.length} skill matches, ${matchingInterests.length} interest matches, score: ${score}`);
          }
  
          // console.log(`Call ${call.code} - Matching Skills:`, matchingSkills);
  
          return { 
            ...call, 
            matchScore: score, 
            skillMatches: matchingSkills.length, 
            interestMatches: matchingInterests.length,
            matchingSkills,
            matchingInterests,
          };
        });
  
        // Filter and sort by match score
        const relevantCallsList = callsWithScores
          .filter(call => call.matchScore > 0)
          .sort((a, b) => b.matchScore - a.matchScore)
          // .slice(0, 5); // Top 5 relevant calls
  
        setRelevantCalls(relevantCallsList);
      } catch (e) {
        console.error('Error fetching relevant calls:', e);
        setRelevantCalls([]);
      
        } finally {
              setLoading(false);
            }
    };
  
  
  
  const filteredCalls = relevantCalls.filter(call => {
    // Match type filter
    if (filterBy === 'skills' && call.skillMatches === 0) return false;
    if (filterBy === 'interests' && call.interestMatches === 0) return false;
    if (filterBy === 'both' && (call.skillMatches === 0 || call.interestMatches === 0)) return false;
    
    // Status filter
    if (statusFilter !== 'all' && call.status !== statusFilter) return false;
    
    // Search query filter (searches across multiple fields)
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      const matchesAgency = call.agency_name?.toLowerCase().includes(query);
      const matchesProgram = call.program_name?.toLowerCase().includes(query);
      const matchesTitle = call.title?.toLowerCase().includes(query) || call.name?.toLowerCase().includes(query) || call.code?.toLowerCase().includes(query);
      const matchesInterest = call.matchingInterests?.some(interest => 
        interest.name?.toLowerCase().includes(query) ||
        interest.code?.toLowerCase().includes(query)
      );
      const matchesSkill = call.matchingSkills?.some(skill => 
        skill.name?.toLowerCase().includes(query)
      );
      
      if (!matchesAgency && !matchesProgram && !matchesTitle && !matchesInterest && !matchesSkill) {
        return false;
      }
    }
    
    return true;
  });

  // Apply sorting
  const sortedCalls = [...filteredCalls].sort((a, b) => {
    if (sortBy === 'score') return b.matchScore - a.matchScore;
    if (sortBy === 'skills') return b.skillMatches - a.skillMatches;
    if (sortBy === 'interests') return b.interestMatches - a.interestMatches;
    if (sortBy === 'deadline') {
      const dateA = a.deadline ? new Date(a.deadline) : new Date('2099-12-31');
      const dateB = b.deadline ? new Date(b.deadline) : new Date('2099-12-31');
      return dateA - dateB;
    }
    if (sortBy === 'status') {
      const statusOrder = { open: 0, upcoming: 1, closed: 2, draft: 3 };
      return (statusOrder[a.status] || 4) - (statusOrder[b.status] || 4);
    }
    return 0;
  });

  const handleSortChange = (event, newSort) => {
    if (newSort !== null) {
      setSortBy(newSort);
    }
  };

  const handleFilterChange = (event, newFilter) => {
    if (newFilter !== null) {
      setFilterBy(newFilter);
    }
  };

  const handleStatusFilterChange = (event, newStatus) => {
    if (newStatus !== null) {
      setStatusFilter(newStatus);
    }
  };

  return (
    <Container maxWidth="xl" sx={{ py: 4, px: { xs: 2, md: 4 } }}>
      {/* Header */}

      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Box>
          <Typography variant="h4" fontWeight={800} sx={{ flex: 1, letterSpacing: 0.2 }} gutterBottom>
            <BackButton position="inline" onClick={() => navigate(`/feed/${profileId || currentUser?.id}/`)} /> All Relevant Calls
           </Typography>
          

           {userProfile && (
            <Typography variant="body1" color="text.secondary" ml={4}>
             All relevant calls matching your profile
            {/* {userProfile.full_name || userProfile.first_name}'s */}
          </Typography>
        )}

        </Box>
        
  


       

        {/* Stats Chips */}
        <Box display="flex" gap={1} mt={2} flexWrap="wrap" alignItems="center">
          <Chip
            label={`${sortedCalls.length} Result${sortedCalls.length !== 1 ? 's' : ''}`}
            color="primary"
            variant="outlined"
          />
          <Chip
            label={`${sortedCalls.filter(c => c.skillMatches > 0).length} Skill Matches`}
            color="primary"
          />
          <Chip
            label={`${sortedCalls.filter(c => c.interestMatches > 0).length} Interest Matches`}
            color="secondary"
            sx={{  color: '#fff' }}
            
          />
          {statusFilter !== 'all' && (
            <Chip
              label={`Status: ${statusFilter.charAt(0).toUpperCase() + statusFilter.slice(1)}`}
              color="info"
              variant="outlined"
              onDelete={() => setStatusFilter('all')}
            />
          )}
          {(statusFilter !== 'all' || searchQuery || filterBy !== 'all') && (
            <Button
              size="small"
              onClick={() => {
                setStatusFilter('all');
                setSearchQuery('');
                setFilterBy('all');
              }}
              sx={{ ml: 1 }}
            >
              Clear All Filters
            </Button>
          )}
        </Box>
      </Box>

      {/* Filters and Sorting */}
      <Paper sx={{ p: 3, mb: 3 }}>
        <Stack spacing={3}>
          {/* Sort and Match Type Filters */}
          <Stack 
            direction={{ xs: 'column', md: 'row' }} 
            spacing={3} 
            alignItems={{ xs: 'stretch', md: 'center' }}
          >
            {/* Sort Controls */}
            <Box>
              <Box display="flex" alignItems="center" gap={1} mb={1}>
                <SortIcon fontSize="small" color="action" />
                <Typography variant="body2" color="text.secondary" fontWeight={600}>
                  Sort By
                </Typography>
              </Box>
              <ToggleButtonGroup
                value={sortBy}
                exclusive
                onChange={handleSortChange}
                size="small"
                aria-label="sort by"
              >
                <ToggleButton value="score">Score</ToggleButton>
                <ToggleButton value="deadline">Deadline</ToggleButton>
                <ToggleButton value="status">Status</ToggleButton>
                <ToggleButton value="skills">Skills</ToggleButton>
                <ToggleButton value="interests">Interests</ToggleButton>
              </ToggleButtonGroup>
            </Box>

            {/* Match Type Filter */}
            <Box>
              <Box display="flex" alignItems="center" gap={1} mb={1}>
                <FilterListIcon fontSize="small" color="action" />
                <Typography variant="body2" color="text.secondary" fontWeight={600}>
                  Match Type
                </Typography>
              </Box>
              <ToggleButtonGroup
                value={filterBy}
                exclusive
                onChange={handleFilterChange}
                size="small"
                aria-label="filter by"
              >
                <ToggleButton value="all">All</ToggleButton>
                <ToggleButton value="skills">Skills Only</ToggleButton>
                <ToggleButton value="interests">Interests Only</ToggleButton>
                <ToggleButton value="both">Both</ToggleButton>
              </ToggleButtonGroup>
            </Box>

            {/* Status Filter */}
            <Box>
              <Box display="flex" alignItems="center" gap={1} mb={1}>
                <FilterListIcon fontSize="small" color="action" />
                <Typography variant="body2" color="text.secondary" fontWeight={600}>
                  Status
                </Typography>
              </Box>
              <ToggleButtonGroup
                value={statusFilter}
                exclusive
                onChange={handleStatusFilterChange}
                size="small"
                aria-label="filter by status"
              >
                <ToggleButton value="all">All</ToggleButton>
                <ToggleButton value="open">Open</ToggleButton>
                <ToggleButton value="upcoming">Upcoming</ToggleButton>
                <ToggleButton value="closed">Closed</ToggleButton>
              </ToggleButtonGroup>
            </Box>
          </Stack>

          {/* Search Box */}
          <Box    width={'50%'}>
       
            <TextField
                fullWidth
              size="small"
              placeholder="Search by agency, program, call title, interests, or skills..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </Stack>
      </Paper>

      {/* Content */}
      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
          <CircularProgress />
        </Box>
      ) : sortedCalls.length === 0 ? (
        <Paper sx={{ p: 4, textAlign: 'center' }}>
          <Typography variant="h6" color="text.secondary" gutterBottom>
            No Relevant Calls Found
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {relevantCalls.length === 0 
              ? "Add skills and research interests to your profile to see relevant funding calls."
              : "No calls match the current filter criteria."}
          </Typography>
          <Button
            variant="contained"
            sx={{ mt: 2 }}
            onClick={() => navigate(`/feed/${profileId || currentUser?.id}/`)}
          >
            Back to Profile
          </Button>
        </Paper>
      ) : (
        <Grid container spacing={3}>
          {sortedCalls.map((call) => (
            <Grid item xs={12} sm={6} md={4} key={call.id}>
              <CallRelevanceCard call={call} />
            </Grid>
          ))}
        </Grid>
      )}
    </Container>
  );
};

export default AllRelevantCalls;
